import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const baseURL = "http://192.168.1.240:10005";
const baseURL = "";

export default class ImpactHistoryService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getOperationHisSearch(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/business/operation-his`, queryForm)
        .then((res) => {
          resolve(res.data.content);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getUserName(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/business/operation-ueser`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public exportExcel(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/operation-his-excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
